import {useEffect} from "react";
import CheckBox from "components/common/CheckBox";
import {closePopup2, getElementCheck, getElementValue, setElementCheck} from "utils/CommonUtils";
import {handleInput} from "utils/wordCheckUtils";
import cross from "assets/icon/cross.svg";
import {setWeatherService} from "../../services/costService";

const WeatherCostPopup = ({shopId, cost, enabled}) => {
  const setEvent = async () => {
    const getCost = getElementValue("weatherCost") || 0;
    const getEnabled = getElementCheck("weatherEnabled");

    const data = {
      shopId: shopId,
      cost: getCost,
      enabled: getEnabled
    };

    await setWeatherService(data);
    window.location.reload();
  }

  useEffect(() => {
    setElementCheck("weatherEnabled", enabled)
  }, [enabled]);

  return (
    <div className="newStyle">
      <div id="weatherCostPopup" className="weatherCostPopup popupContainer d-flex a-center j-center d-none">
        <div className="popupBody w-360 bc-FF">
          <div className="titleBox d-flex a-center j-between">
            <p className="fs-24 fw-7">기상할증 설정</p>
            <button onClick={() => closePopup2("weatherCostPopup")}>
              <img src={cross} alt="닫기" />
            </button>
          </div>
          <div className="bodyBox scrollbar">
            <div className="popupInputBox d-flex a-center j-left mb-15">
              <div className="inputLabel fw-7">할증금액</div>
              <div className="inputBox d-flex a-center j-left">
                <input
                  id="weatherCost"
                  className="br-6 w-120 mr-5"
                  key={`weatherCost-${cost}`}
                  type="text"
                  defaultValue={cost}
                  maxLength={5}
                  onInput={(e) => handleInput(e, "number")}
                />
                원
              </div>
            </div>
            <div className="popupInputBox d-flex a-center j-left">
              <div className="inputLabel fw-7">사용여부</div>
              <div className="inputBox d-flex a-center j-left">
                <CheckBox
                  id="weatherEnabled"
                  label="사용"
                  checked={enabled}
                  disabled={false}
                />
              </div>
            </div>
          </div>
          <div className="btnBox">
            <button
              className="fs-20 fw-7 bc bc-ACB2B8 fc-FF"
              onClick={() => closePopup2("weatherCostPopup")}
            >
              취소
            </button>
            <button className="fs-20 fw-7 bc-0764A9 fc-FF" onClick={setEvent}>수정</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherCostPopup;